import { render } from "./TroyersDelight.vue?vue&type=template&id=3ab36306&scoped=true"
import script from "./TroyersDelight.vue?vue&type=script&lang=js"
export * from "./TroyersDelight.vue?vue&type=script&lang=js"

import "./TroyersDelight.vue?vue&type=style&index=0&id=3ab36306&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab36306"]])

export default __exports__